import React from 'react'
import { Button } from '@mui/material'


const ButtonWrapper = ({ children, ...otherProps }) => {

  const configButton = {
    variant: 'contained',
    color: 'primary',
    fullWidth: true,
    // onClick: handleSubmit,
    ...otherProps,
  }

  return (
    <Button
      {...configButton}
    >
      {children}
    </Button>
  );
}

export default ButtonWrapper;